import { CardComponentProps } from "@~/types/types";
import { isBladedArticleProduct } from "../../utils/product";
import styles from "./AgeVerification.module.scss";

export function AgeVerification({
  product,
}: Pick<CardComponentProps, "product">) {
  const bladedArticle = isBladedArticleProduct(product);

  if (!bladedArticle) return null;

  return (
    <div className={styles.container} data-component="pcl-AgeVerification">
      Age verification required at checkout and delivery
    </div>
  );
}
